import { createSlice } from '@reduxjs/toolkit'

const shopItemsSlice = createSlice({
    name: 'shopItems',
    initialState: {
        productList: [],
        productsFeature: []
    },
    reducers: {
        fetchStoreItemsAction: (state, action) => {
            state.productList = [action.payload]
        },
        fetchStoreFeaturedAction: (state, action) => {
            state.productsFeatured = [action.payload][0]
        }
    }

})
export const {fetchStoreItemsAction, fetchStoreFeaturedAction} = shopItemsSlice.actions


export default shopItemsSlice
